import { FC, memo } from "react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { GroupDeletedDef } from "@/features/groups/types/group.type";
import { formatDistance } from "@/utils/date";
import { extractUsername } from "@/utils/extractUsername";

type GroupDeletedCardProps = {
  group: GroupDeletedDef;
  onOk: () => void;
};

const GroupDeletedCard: FC<GroupDeletedCardProps> = ({ group, onOk }) => {
  return (
    <div className="py-4 border-secondary-200 border-b last:border-b-0 first:border-t flex justify-between items-center">
      <div className="flex gap-2 items-center">
        <Avatar className="h-10 w-10">
          <AvatarImage src={group.photoUrl || ""} />
          <AvatarFallback>
            {group.name?.charAt(0) || extractUsername(group.name || "")}
          </AvatarFallback>
        </Avatar>
        <div>
          <p className="text-secondary-900 font-medium mb-0 text-sm -mb-1">
            {group.name}
          </p>
          <div className="text-secondary-600  flex items-center gap-1">
            <span>Đã xoá</span>
            <span>{formatDistance(group.deletedAt)} </span>trước
          </div>
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          className="w-full"
          variant="ghost"
          onClick={onOk}
        >
          Khôi phục
        </Button>
      </div>
    </div>
  );
};

export default memo(GroupDeletedCard);
